// src/components/Sidebar.jsx
import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import {
  FaUsers,
  FaClipboardList,
  FaTachometerAlt,
  FaRoute,
  FaHistory,
} from "react-icons/fa";

const WIDTH = 220; // px

const SidebarWrap = styled.aside`
  width: ${WIDTH}px;
  background: #ffffff;
  position: fixed;
  top: 60px; /* below navbar */
  left: ${props => (props.open ? "0" : `-${WIDTH}px`)};
  height: calc(100vh - 60px);
  box-shadow: 2px 0 10px rgba(0,0,0,0.06);
  transition: left 260ms ease;
  z-index: 1100;
  padding-top: 18px;

  @media(min-width: 992px) {
    left: 0;
  }

  @media(max-width: 480px) {
    width: 200px;
  }
`;

const Menu = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0.5rem;
`;

const StyledLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  color: #374151;
  text-decoration: none;
  border-radius: 8px;
  margin: 0 8px;

  &.active {
    background: linear-gradient(90deg, #ffedd5, #fff7ed);
    color: #c2410c;
    font-weight: 700;
  }

  &:hover {
    background: #fff7ed;
    color: #c2410c;
  }
`;

const Sidebar = ({ open, onClose }) => {
  // onClose is called after clicking a link on mobile to auto-close
  const handleClick = () => {
    if (window.innerWidth < 992 && typeof onClose === "function") onClose();
  };

  return (
    <SidebarWrap open={open}>
      <Menu>
        <StyledLink to="/dashboard" onClick={handleClick}>
          <FaTachometerAlt /> Dashboard
        </StyledLink>

        <StyledLink to="/users" onClick={handleClick}>
          <FaUsers /> Users
        </StyledLink>

        <StyledLink to="/entries" onClick={handleClick}>
          <FaClipboardList /> Entries
        </StyledLink>

        <StyledLink to="/history" onClick={handleClick}>
          <FaHistory /> History
        </StyledLink>

        <StyledLink to="/routes" onClick={handleClick}>
          <FaRoute /> Routes
        </StyledLink>
        <StyledLink to="/master-files" onClick={handleClick}>
          <FaRoute /> Master Files
        </StyledLink>
      </Menu>
    </SidebarWrap>
  );
};

export default Sidebar;
